import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";
import {
    AWAY_TRIP_STATUSES,
    AWAY_TRIP_STATUS_BADGE_CLASSES,
    AWAY_TRIP_STATUS_REQUESTED
} from "./AwayTripsConstants";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";

export default class AwayTripListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStatusInfo = status => ({
        label: AWAY_TRIP_STATUSES[status] || AWAY_TRIP_STATUSES[AWAY_TRIP_STATUS_REQUESTED],
        className: AWAY_TRIP_STATUS_BADGE_CLASSES[status] || AWAY_TRIP_STATUS_BADGE_CLASSES[AWAY_TRIP_STATUS_REQUESTED]
    });

    handleOpenClick = _ => {
        if (this.props.onOpen) {
            this.props.onOpen(this.props.item);
        }
    }

    render() {
        const item = this.props.item || {};
        const staff = this.props.staff || {};
        const negozio = staff.negozio || item.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        const statusInfo = this.getStatusInfo(item.status);
        const startDate = item.start_date ? moment(item.start_date).format("DD/MM/YYYY") : "-";
        const endDate = item.end_date ? moment(item.end_date).format("DD/MM/YYYY") : "-";
        const dateRange = startDate === endDate ? `Il ${startDate}` : `Dal ${startDate} al ${endDate}`;
        const fromCity = item.from_city_name || "-";
        const toCity = item.to_city_name || "-";
        const updatedAt = item.updated_at ? moment(item.updated_at).format("ddd DD MMMM HH:mm") : "-";

        return (
            <button
                type={"button"}
                className={"list-group-item list-group-item-action text-left"}
                onClick={this.handleOpenClick}
            >
                <div className={"d-flex justify-content-between align-items-start"}>
                    <div className={"d-flex align-items-center"}>
                        <AppIconThumbnail size={"32px"} src={negozioIconUrl} className={"mr-2"}/>
                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                    </div>
                    <span className={statusInfo.className}>{statusInfo.label}</span>
                </div>
                <div className={"small text-muted mt-1"}>
                    <FaSolidIcon name={"route"}/> {fromCity} - {toCity}
                </div>
                <div className={"small text-muted"}>
                    <FaSolidIcon name={"calendar-alt"}/> {dateRange}
                </div>
                <div className={"small text-muted"}>
                    Ultimo aggiornamento: {updatedAt}
                </div>
            </button>
        );
    }
}

AwayTripListItem.propTypes = {
    item: PropTypes.object,
    staff: PropTypes.object,
    onOpen: PropTypes.func
};
